import { createAction, props } from '@ngrx/store';
import { Popups, PopupsDTO, PopupsFilters } from '../../commons/models/popups';

export const loadPopups = createAction('[Popups] Load Popups', props<{ page?: number, perPage?: number, order?: string, direction?: string, filters?: PopupsFilters, includes?: string[] }>());
export const loadPopupsCompleted = createAction('[Popups] Load Popups Completed', props<{ popups: PopupsDTO[], currentPage: number, total: number, perPage: number, order?: string, direction?: string, filters?: PopupsFilters, includes?: string[] }>());
export const loadPopupsFailed = createAction('[Popups] Load Popups Failed', props<{ error: any }>());

export const changePage = createAction('[Popups] Change page', props<{ page: number, size: number }>());
export const changeSort = createAction('[Popups] Change sort', props<{ order: string, direction: string }>());
export const changeFilters = createAction('[Popups] Change filters', props<{ filters: PopupsFilters }>());

export const editPopup = createAction('[Popups] Edit popup', props<{ popup: Popups }>());
export const popupDialogOpened = createAction('[Popups] Detail dialog opened', props<{ dialogId: string }>());
export const closePopupsDialog = createAction('[Popups] Close detail dialog');
export const requestClosePopupsDialog = createAction('[Popups] Request Close Dialog');
export const confirmClosePopupsDialog = createAction('[Popups] Confirm Close Dialog');
export const cancelClosePopupsDialog = createAction('[Popups] Cancel Close Dialog');


export const showPopups = createAction('[Popups] Show popup', props<{ popup: Popups }>());
export const addPopups = createAction('[Popups] Add popup');
export const loadPopup = createAction('[Popups] Load popup', props<{ id: number }>());
export const loadPopupCompleted = createAction('[Popups] Load popup Completed', props<{ popup: PopupsDTO }>());
export const loadPopupFailed = createAction('[Popups] Load popup Failed', props<{ error: any }>());

export const savePopup = createAction('[Popups] Save popup', props<{ popup: Popups }>());
export const savePopupCompleted = createAction('[Popups] Save popup completed', props<{ popup: PopupsDTO }>());
export const savePopupsFailed = createAction('[Popups] Save popup failed', props<{ error: any }>());

export const deletePopup = createAction('[Popups] Delete popup', props<{ popup: PopupsDTO }>());
export const deletePopupCompleted = createAction('[Popups] Delete popup completed', props<{ popup: PopupsDTO }>());
export const deletePopupCancelled = createAction('[Popups] Delete popup cancelled');
export const deletePopupFailed = createAction('[Popups] Delete popup failed', props<{ error: any }>());

export const selectPopup = createAction('[Popups] Select popup', props<{ filters?: PopupsFilters }>());
export const selectionDialogOpened = createAction('[Popups] Selection dialog opened', props<{ selectionDialogId: string }>());
export const closeSelectionDialog = createAction('[Popups] Close selection dialog');
export const popupSelected = createAction('[Popups] Popup selected', props<{ popup: PopupsDTO }>());

export const addSelectPopups = createAction('[Popups] Add selected popup', props<{ popup: Popups }>());
export const removeSelectedPopups = createAction('[Popups] Remove selected popup', props<{ popup: Popups }>());